export default (that) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'defaultImageUrl',
    width: 80,
    title: that.$l('INDEX.table_label_image') || '图片',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' },
  },

  {
    title: that.$l('INDEX.evg_sku_label_specName') || '规格名称',
    field: 'specName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'specName' },
  },
  {
    title: that.$l('table_label_NCcoding') || 'NC编码',
    field: 'specNcNo',
    minWidth: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInput',
      props: {
        maxlength: 50,
        'show-word-limit': true,
        clearable: true,
        size: 'mini',
      },
    },
  },
]
